import type { SubsampleInformationBox } from '../boxes/SubsampleInformationBox.ts'
import type { IsoBoxReadView } from '../IsoBoxReadView.ts'

/**
 * Parse a `SubsampleInformationBox` from an `IsoBoxReadView`.
 *
 * @param view - The `IsoBoxReadView` to read data from
 *
 * @returns A parsed `SubsampleInformationBox`
 *
 * @public
 */
export function readSubs(view: IsoBoxReadView): SubsampleInformationBox {
	const { version, flags } = view.readFullBox()
	const entryCount = view.readUint(4)
	const entries = view.readEntries(entryCount, () => {
		const sampleDelta = view.readUint(4)
		const subsampleCount = view.readUint(2)
		const subsamples = view.readEntries(subsampleCount, () => ({
			subsampleSize: view.readUint((version === 1) ? 4 : 2),
			subsamplePriority: view.readUint(1),
			discardable: view.readUint(1),
			codecSpecificParameters: view.readUint(4),
		}))

		return {
			sampleDelta,
			subsampleCount,
			subsamples,
		}
	})

	return {
		type: 'subs',
		version,
		flags,
		entryCount,
		entries,
	}
};
